import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import all from 'prop-types-extra/lib/all';
import Button from './Button';
import { bsClass, getClassSet, prefix, splitBsProps } from './utils/bootstrapUtils';
class ButtonGroup extends React.Component {
  render() {
    const {
      block,
      justified,
      vertical,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = {
      ...getClassSet(bsProps),
      [prefix(bsProps)]: !vertical,
      [prefix(bsProps, 'vertical')]: vertical,
      [prefix(bsProps, 'justified')]: justified,
      // this is annoying, since the class is `btn-block` not `btn-group-block`
      [prefix(Button.defaultProps, 'block')]: block
    };
    return /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }));
  }
}
ButtonGroup.defaultProps = {
  block: false,
  justified: false,
  vertical: false
};
export default bsClass('btn-group', ButtonGroup);